export { default as addClient } from "./clients/addClient";
export { default as removeClient } from "./clients/removeClient";
export { default as selectClient } from "./clients/selectClient";
export { default as deselectClient } from "./clients/deselectClient";
export { default as setPrivileges } from "./clients/setPrivileges";

export { default as toggleOktellSync } from "./calls/toggleOktellSync";
export { default as acceptIncomingCall } from "./calls/acceptIncomingCall";
export { default as muteIncomingCall } from "./calls/muteIncomingCall";
export { default as clearOngoingCall } from "./calls/clearOngoingCall";

export { default as createSupportTicket } from "./tickets/createSupportTicket";
export {
  default as clearSupportTicketRequest,
} from "./tickets/clearSupportTicketRequest";



// WEBPACK FOOTER //
// ./src/model/subsystems/clients/actions/index.js